"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormFieldLabel = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcPopover_1 = require("../display/AcPopover");
var AcFormFieldBadge_1 = require("./AcFormFieldBadge");
var AcFormFieldLabel = function (_a) {
    var label = _a.label, tooltip = _a.tooltip, className = _a.className, required = _a.required, readOnly = _a.readOnly, type = _a.type;
    if (!label)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "d-flex align-items-center" },
        react_1.default.createElement(react_bootstrap_1.Form.Label, { className: className }, label),
        tooltip && (react_1.default.createElement(react_bootstrap_1.Form.Label, { className: className },
            react_1.default.createElement(AcPopover_1.AcPopover, { placement: "top", text: tooltip, dark: true },
                react_1.default.createElement("i", { className: "fa fa-question-circle fs-12 ml-2" })))),
        required && !readOnly && type && ['checkbox', 'radio', 'switch', 'custom'].includes(type) && (react_1.default.createElement("span", { className: "ml-2 mb-2" },
            react_1.default.createElement(AcFormFieldBadge_1.AcFormFieldBadge, { type: "required" })))));
};
exports.AcFormFieldLabel = AcFormFieldLabel;
exports.AcFormFieldLabel.displayName = 'AcFormFieldLabel';
//# sourceMappingURL=AcFormFieldLabel.js.map